import React, { Component } from 'react';
import Header from './components/Header';
import ChairmanMessage from './components/ChairmanMessage';
import FinancialMetrics from './components/FinancialMetrics';
import AIStrategy from './components/AIStrategy';
import Awards from './components/Awards';
import Footer from './components/Footer';
import VerticalMenu from './components/VerticalMenu'; // 🆕 Import menu
import './assets/fonts/Inter_28pt-Regular.ttf';
import './assets/fonts/Inter_28pt-SemiBold.ttf';
import './assets/fonts/Inter_28pt-Bold.ttf';

import { Drawer } from 'antd';


import './index.css'
import StoreManager from './appdata';

import HomeScreen from './screens/HomeScreen'
import AboutScreen from './screens/AboutScreen'
import DigitalTransformationScreen from './screens/DigitalTransformationScreen'
import BusinessStrategyScreen from './screens/BusinessStrategyScreen'
import ManagementReportScreen from './screens/ManagementReportScreen'
import DesktopMenu from './components/DesktopMenu'
import MobileMenu from './components/MobileMenu'

import {
  MenuOutlined,
  GlobalOutlined,
  HomeOutlined,
  FieldTimeOutlined,
  ClusterOutlined,
  AimOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import languages from './appdata/languages';

const iconMap = {
  HomeOutlined: <HomeOutlined />,
  FieldTimeOutlined: <FieldTimeOutlined />,
  ClusterOutlined: <ClusterOutlined />,
  AimOutlined: <AimOutlined />,
  BarChartOutlined: <BarChartOutlined />,
};

class App extends Component {

  constructor(props) {
    super(props);
    const savedLanguage = localStorage.getItem('lang') || 'en'; // default 'en'
  
    this.state = {
      isMobile: window.innerWidth < 768,
      currentPage: 'HomeScreen',
      subPageContent: 'AboutContent',
      currentLanguage: savedLanguage,
      visible: false,
      currentPath: '/',
    };
    StoreManager.appState.thisApp = this;
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateDevice);
  
    const path = window.location.pathname;
    const currentPage = this.getPageFromPath(path);
    const subPageContent = this.getSubPageFromPath(path);
  
    this.setState({
      currentPath: path,
      currentPage,
      subPageContent,
    });
  }
  
  

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDevice);
  }

  navigateTo = (path) => {
    const currentPage = this.getPageFromPath(path);
    window.history.pushState({}, '', path); // update URL without reload
    this.setState({ currentPath: path, currentPage });
  }

  getPageFromPath = (path) => {
    if (path === '/' || path === '') {
      return 'HomeScreen';
    }
  
    if (path.startsWith('/about')) {
      return 'AboutScreen';
    }
  
    if (path.startsWith('/digital')) {
      return 'DigitalTransformationScreen';
    }
  
    if (path.startsWith('/strategy')) {
      return 'BusinessStrategyScreen';
    }
  
    if (path.startsWith('/report')) {
      return 'ManagementReportScreen';
    }
  
    return 'HomeScreen'; // fallback
  };

  getSubPageFromPath = (path) => {
    switch (path) {
      case '/about':
        return 'AboutContent';
      case '/about/game':
        return 'Game2024Content';
      case '/about/zalo':
        return 'Zalo2024Content';
      case '/about/zalopay':
        return 'Zalopay2024Content';
      case '/about/digital-business':
        return 'DigitalBusiness2024Content';
      case '/about/people-strategy':
        return 'VNGPeopleStrategyContent';
      case '/about/csr':
        return 'VNGsApproachToCSRContent';
  
      case '/digital':
        return 'DigitalTransformationContent';
      
      case '/strategy':
          return 'Highlight2024Content';

      case '/strategy/highlight':
        return 'Highlight2024Content';
      case '/strategy/structure':
        return 'CorporateStructureContent';
      case '/strategy/macroeconomy':
        return 'MacroeconomicOverviewContent';
  
      case '/report':
        return 'ManagementReportContent1';
      case '/report/mda':
        return 'ManagementReportContent1';
      case '/report/analysis':
        return 'ManagementReportContent2';
      case '/report/assessment':
        return 'ManagementReportContent3';
  
      default:
        return 'AboutContent';
    }
  };
  

  updateDevice = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };
  showDrawer = () => this.setState({ visible: true });
  closeDrawer = () => this.setState({ visible: false });

  render() {
    const {isMobile, currentPage, currentLanguage, visible} = this.state
    const lang = languages[currentLanguage].HeaderContent;

    return (
      <div className="App">
        <DesktopMenu isMobile={isMobile} showDrawer={this.showDrawer} />

        {!isMobile && <VerticalMenu />} {/* 🆕 Show menu outside */}
        {
          currentPage == 'HomeScreen' ?  <HomeScreen/> : <></>
        }
        {
          currentPage == 'AboutScreen' ?  <AboutScreen/> : <></>
        }
        {
          currentPage == 'DigitalTransformationScreen' ?  <DigitalTransformationScreen/> : <></>
        }
          {
          currentPage == 'BusinessStrategyScreen' ?  <BusinessStrategyScreen/> : <></>
        }
         {
          currentPage == 'ManagementReportScreen' ?  <ManagementReportScreen/> : <></>
        }
 
        <Drawer
          title={null}
          placement="right"
          onClose={this.closeDrawer}
          open={visible}
          bodyStyle={{ padding: 0 }}
          width="80%" // tuỳ chỉnh chiều rộng Drawer nếu cần
        >
          <MobileMenu onClose={this.closeDrawer} />
        </Drawer>

      </div>
    );
  }
}

export default App;
